import React, { useContext, useState, useEffect } from "react";

const StateContext = React.createContext();
export function useStateContext() {
  return useContext(StateContext);
}

export default function StateProvider({ children }) {
  const freeshippingRate = 50000;
  const shippingRate = 5000;
  const [emailInBasket, setEmailInBasket] = useState(null);
  const [basket, setBasket] = useState(
    JSON.parse(localStorage.getItem("basket")) || []
  );
  const [tax, setTax] = useState(0);
  const [taxPrice, setTaxPrice] = useState(0);
  const [shippingOption, setShipingOption] = useState("Standard");

  const free_shipping = 0;
  const standard_shipping = 5000;

  const value = {
    basket,
    addToBasket,
    getBasketTotal,
    removeItemFromBasket,
    getBasketQuantity,
    modifyQuantityInBasket,
    addOneItemToBasket,
    removeOneItemToBasket,
    emptyBasket,
    ChangeQuantityToBasket,
    getShipping,
    setTax,
    tax,
    getSubtotal,
    freeshippingRate,
    shippingOption,
    setShipingOption,
    taxPrice,
    setTaxPrice,
    emailInBasket,
    setEmailInBasket,
    shippingRate,
    setBasket,
  };
  console.log("basket", basket);

  useEffect(() => {
    localStorage.setItem("basket", JSON.stringify(basket));
  }, [basket]);

  function getSubtotal() {
    let subtotal = basket?.reduce(
      (amount, item) => item.price * item.quantity + amount,
      0
    );
    return subtotal;
  }

  function getShipping() {
    if (getSubtotal() > freeshippingRate) {
      return free_shipping;
    } else {
      return standard_shipping;
    }
  }

  function getBasketTotal() {
    let subtotal = getSubtotal();
    let salesTaxPrice = 0;
    if (tax > 0) {
      salesTaxPrice = +subtotal * +tax;
      if (salesTaxPrice !== 0) {
        salesTaxPrice = salesTaxPrice.toFixed(2);
      }
      setTaxPrice(salesTaxPrice);
    }
    if (subtotal < freeshippingRate) {
      subtotal = parseFloat(subtotal) + shippingRate;
    }
    return subtotal;
  }

  function emptyBasket() {
    setBasket([]);
  }
  function addToBasket(item) {
    let found = false;

    basket.map((basketEach) => {
      if (basketEach.id === item.id) {
        found = true;
        let basketQuantity = +basketEach.quantity;
        let quantity = +item.quantity;

        let newBasketEach = {
          ...basketEach,
          quantity: basketQuantity + quantity,
        };

        //Find index of specific object using findIndex method.
        let objIndex = basket.findIndex((bs) => bs.id === item.id);
        //Log object to Console.
        console.log("Before update: ", basket[objIndex]);

        //Update object's name property.
        basket[objIndex] = newBasketEach;

        //Log object to console again.
        console.log("After update: ", basket[objIndex]);

        // let removed = basket.filter((bs) => bs.id !== item.id);
        // setBasket((oldArray) => [...removed, newBasketEach]);
      }
    });
    if (!found) {
      setBasket((oldArray) => [...oldArray, item]);
    }
  }
  function addToBasket(item, numOfProduct) {
    console.log("addToBasket(item, numOfProduct)");
    console.log("numOfProduct", numOfProduct);
    let found = false;

    basket.map((basketEach) => {
      if (basketEach.id === item.id) {
        found = true;
        let basketQuantity = +basketEach.quantity;
        let quantity = +item.quantity;

        let newBasketEach;

        if (numOfProduct < basketQuantity + quantity) {
          newBasketEach = {
            ...basketEach,
            quantity: +numOfProduct,
          };
        } else {
          newBasketEach = {
            ...basketEach,
            quantity: basketQuantity + quantity,
          };
        }

        let temp = basket;
        //Find index of specific object using findIndex method.
        let objIndex = temp.findIndex((bs) => bs.id == item.id);
        //Log object to Console.
        console.log("Before update: ", temp[objIndex]);
        //Update object's name property.
        temp[objIndex] = newBasketEach;
        //Log object to console again.
        console.log("After update: ", temp[objIndex]);
        setBasket((old) => [...temp]);

        console.log("basket after update", basket);

        // let removed = basket.filter((bs) => bs.id !== item.id);
        // setBasket((oldArray) => [...removed, newBasketEach]);
      }
    });
    if (!found) {
      setBasket((oldArray) => [...oldArray, item]);
    }
  }
  function ChangeQuantityToBasket(id, newQuantity) {
    let res = basket?.map((basketEach) => {
      if (basketEach.id === id) {
        let newBasketEach = {
          ...basketEach,
          quantity: newQuantity,
        };

        let temp = basket;
        //Find index of specific object using findIndex method.
        let objIndex = temp.findIndex((bs) => bs.id == id);
        //Log object to Console.
        console.log("Before update: ", temp[objIndex]);
        //Update object's name property.
        temp[objIndex] = newBasketEach;
        //Log object to console again.
        console.log("After update: ", temp[objIndex]);
        setBasket((old) => [...temp]);

        console.log("basket after update", basket);

        // let removed = basket.filter((bs) => bs.id !== id);
        // setBasket((oldArray) => [...removed, newBasketEach]);
      }
    });
  }
  function removeOneItemToBasket(id) {
    basket.map((basketEach) => {
      if (basketEach.id === id) {
        let basketQuantity = +basketEach.quantity;
        if (basketQuantity > 1) {
          let newBasketEach = {
            ...basketEach,
            quantity: basketQuantity - 1,
          };

          let removed = basket.filter((bs) => bs.id !== id);
          setBasket((oldArray) => [...removed, newBasketEach]);
        }
      }
    });
  }
  function addOneItemToBasket(id) {
    basket.map((basketEach) => {
      if (basketEach.id === id) {
        let basketQuantity = +basketEach.quantity;

        let newBasketEach = {
          ...basketEach,
          quantity: basketQuantity + 1,
        };

        let removed = basket.filter((bs) => bs.id !== id);
        setBasket((oldArray) => [...removed, newBasketEach]);
      }
    });
  }
  function modifyQuantityInBasket(id, quantity) {
    let found = false;
    basket.map((basketEach) => {
      if (basketEach.id === id) {
        found = true;
        let newBasketEach = { ...basketEach, quantity: quantity };
        let removed = basket.filter((bs) => bs.id !== id);
        setBasket((oldArray) => [...removed, newBasketEach]);
      }
    });
  }
  function getBasketQuantity() {
    console.log("basket in context", basket);

    let total = basket?.reduce(function (prev, current) {
      return prev + +current.quantity;
    }, 0);
    return total;
  }

  function removeItemFromBasket(id) {
    console.log("removeItemFromBasket");
    let removed = basket?.filter((basketEach) => id !== basketEach.id);
    setBasket((oldArray) => removed);
  }

  return (
    <StateContext.Provider value={value}>{children}</StateContext.Provider>
  );
}
